import { handleActions } from "redux-actions";
import {
    SHOW_SETTINGS,
    HIDE_SETTINGS,
    SET_PAYMENT_SESSION_ID,
    SET_USERDATA,
    SET_SOUND_ENABLE, REDIRECT_TO_PAYMNET,
} from "../actions/SettingsActions";

const initialState = {
  settingsActive: false,
  paymentSessionId: false,
  directPayment: false,
  userdata: {},
};

export const SettingsReducer = handleActions(
  {
    [SHOW_SETTINGS]: (state) => ({
      ...state,
      settingsActive: true,
    }),
    [HIDE_SETTINGS]: (state) => ({
      ...state,
      settingsActive: false,
    }),
    [SET_PAYMENT_SESSION_ID]: (state, action) => ({
      ...state,
      paymentSessionId: action.payload,
    }),
    [SET_USERDATA]: (state, action) => ({
      ...state,
      userdata: action.payload,
    }),
    [SET_SOUND_ENABLE]: (state, action) => ({
      ...state,
      userdata: {
        ...state.userdata,
        sound: action.payload,
      },
    }),
      [REDIRECT_TO_PAYMNET]: (state) => ({
          ...state,
          directPayment: true,
      }),
  },
  initialState
);
